import { FieldHeaderComponent, TextFormFieldComponent } from '@vivli/shared/components';
import React from 'react';
import { useActiveUserContext } from '@vivli/core/infrastructure/context';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';

const containerStyle = {
    display: 'grid',
    gridAutoRows: 'auto',
    rowGap: '20px',
    paddingRight: '40px',
};

export const OrgDetailsBasicInformation = () => {
    //TODO PERMFE - redo with permissions+
    const isVivliAdmin = useActiveUserContext().hasPermission(PermissionsEnum.CreateOrg);

    return (
        <div style={containerStyle}>
            <FieldHeaderComponent title={'BASIC INFORMATION'} />
            <TextFormFieldComponent name={'name'} label={'Organization Name'} readonly={!isVivliAdmin} />
            <TextFormFieldComponent name={'billingCountry'} label={'Country'} readonly={!isVivliAdmin} />
        </div>
    );
};
